import React from 'react';
import { StyledCardText, StyledCardType, StyledVideoCard } from './VideoCard.style';

const VideoCard = ({
  title, type, thumbnail, onClick, isActive,
}) => (
  <StyledVideoCard thumbnail={`https://vumbnail.com/${thumbnail}.jpg`} onClick={onClick} isActive={isActive}>
    <StyledCardText>{title}</StyledCardText>
    <StyledCardType type={type}>{type}</StyledCardType>
  </StyledVideoCard>
);

export default VideoCard;
